import { useMsal } from '@azure/msal-react';
import React, {useState, useEffect} from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import  {useTranslation} from 'react-i18next';
import { ApiProvider } from '../../providers/apiProvider';
// import JobsiteIdList from '../controls/JobsiteIdList';
import { SelectField, InputField, TypeaheadSelectorField, useFormContext } from 'clayco-controls';
import { log } from 'utils/logging';

const AssignmentInfo = ({ preloadedAssignment, showLoading }) => {
    const {t} = useTranslation();
    const {instance, accounts} = useMsal();
    const _api = new ApiProvider(instance, accounts[0]);
    const { setValue } = useFormContext();

    // conditions
    const [areProjectLoaded, setAreProjectLoaded] = useState(false);
    const [areCraftsLoaded, setAreCraftsLoaded] = useState(false);
    const [areRolesLoaded, setAreRolesLoaded] = useState(false);
    const [loadingEmployees, setLoadingEmployees] = useState(false);
    // const [jobsiteIdCount, setJobsiteIdCount] = useState(1);
    // const [disableJobsiteIdValue, setDisableJobsiteIdValue] = useState([true, true, true]);

    // selections
    const [selectedProject, setSelectedProject] = useState(null);
    const [preloadedProject, setPreloadedProject] = useState(null);

    // records
    const [projects, setProjects] = useState([]);
    const [employers, setEmployers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [crafts, setCrafts] = useState([]);
    // const [jobsiteIdTypes, setJobsiteIdTypes] = useState([]);

    // select preloaded role
    useEffect(()=>{

        if (preloadedAssignment != null) {
            const selectedRole = roles.find(r => r.name === preloadedAssignment.role);
            log.trace('selectedRole', selectedRole);

            setValue("assignmentInfo.role", selectedRole.id);
        }

    }, [preloadedAssignment, areRolesLoaded]);

    // select preloaded craft
    useEffect(()=>{

        if (preloadedAssignment != null) {
            const selectedCraft = crafts.find(r => r.name === preloadedAssignment.craft);
            log.trace('selectedCraft', selectedCraft);

            setValue("assignmentInfo.craft", selectedCraft.id);
        }

    }, [preloadedAssignment, areCraftsLoaded]);

    // load projects
    useEffect(()=>{

        const loadProjects = async () =>{
            var path = window.location.pathname.split('/').pop();
            var reg = new RegExp(/^\d+$/);

            if(reg.test(path)){
                showLoading(true);
                var project = await _api.Get(`project/getbynumber/${path}`);
                showLoading(false);
                setProjects([project]);
                setSelectedProject([project]);
                setValue("assignmentInfo.project", project);
                setAreProjectLoaded(true);

                const employers = await fetchEmployers(path);
                setEmployers(employers);
                return;
            }

            showLoading(true);
            const projects = await _api.Get("project/getallactive");
            showLoading(false);
            if (projects.error != null){
                console.error('failed to load projects')
            }
            else{

                setProjects(projects);
                
                if (preloadedAssignment != null) {
                    await handleProjectSelect(preloadedAssignment.project);
                    setPreloadedProject(preloadedAssignment.project);
                    setValue("assignmentInfo.organization", preloadedAssignment.organization.id);
                }
            }
            
        };

        loadProjects();
        
       setValue(`jobsiteId.0.added`, true)
    }, [preloadedAssignment]); // eslint-disable-line react-hooks/exhaustive-deps

    // load crafts, roles, jobsiteIds
    useEffect(()=>{
        
        const loadCrafts = async () => {
            showLoading(true);
            var crafts = await _api.Get(`craft/getall/${window.language}`);
            setAreCraftsLoaded(true);
            showLoading(false);
            if (!crafts.error){
                setCrafts(crafts);
            }
        };
        const loadRoles = async () => {
            showLoading(true);
            var roles = await _api.Get(`role/getall/${window.language}`);
            setAreRolesLoaded(true);
            showLoading(false);

            if (!roles.error){
                setRoles(roles);
            }
        };
        // const loadJobsiteIdTypes = async () => {
        //     showLoading(true);
        //     var jobsiteIdTypes = await _api.Get(`jobsiteIdType/getall/${window.language}`);
        //     showLoading(false);

        //     if (!jobsiteIdTypes.error){
        //         setJobsiteIdTypes([{id: '', name: ''}, ...jobsiteIdTypes]);
        //     }
        // };

        loadCrafts();
        loadRoles();
        //loadJobsiteIdTypes();

    }, [window.language]); // eslint-disable-line react-hooks/exhaustive-deps

    // load employers
    const fetchEmployers = async(projectNumber) => {

        const allEmployers = await _api.Get(`organization/getbyproject/${projectNumber}`);
 
        const employers = allEmployers.filter(emp => {

            return emp.id !== 0 
                ? emp 
                : { ...emp,  id: emp.snowflakeId, isIdSnowflake: true }
        });

        return employers;
    }

    // --------------------------------------------------------------------
    // handle selections
    // --------------------------------------------------------------------

    const onProjectSelect = async (projectAr) => {

        const project = projects.find(r => r.number === projectAr[0]?.number );
        handleProjectSelect(project);
    }

    const handleProjectSelect = async (project) => {
        log.trace('handleProjectSelect', 'project', project);

        if (project != null){
            setValue("assignmentInfo.projectNumber", project.number);
            setValue("assignmentInfo.project", project);
            setLoadingEmployees(true);

            showLoading(true);
            let employers = await fetchEmployers(project.number);
            log.trace('handleProjectSelect', 'employers', employers);
            showLoading(false);

            setEmployers(employers);
            setLoadingEmployees(false);
            setAreProjectLoaded(true);
        }
    }

    const onEmployerSelect = (value) =>{
        let selectedValue = parseInt(value);        
        let selected = employers?.filter((emp)=> { return emp.id === selectedValue});
        
        setValue("assignmentInfo.employer", selected[0]);
        setValue("assignmentInfo.employerId", selected[0]?.id);
    }

    // const jobsiteIdTypeChange = (idx, value) => {

    //     const hasValue = value != null && value.trim() !== '';

    //     let disableValues = [...disableJobsiteIdValue];

    //     if (hasValue) {
    //         disableValues[idx] = false;
    //     }
    //     else {
    //         setValue(`jobsiteId.${idx}.value`, '');
    //         disableValues[idx] = true;
    //     }
    //     setDisableJobsiteIdValue(disableValues);

    // }

    // const addJobsiteId = () => {
    //     const idx = jobsiteIdCount+1;
    //     setJobsiteIdCount(idx);
    //     setValue(`jobsiteId.${idx}.jobsiteIdType`, '')
    //     setValue(`jobsiteId.${idx}.value`, '')
    //     setValue(`jobsiteId.${idx}.added`, true)
    // }

    // const removeJobsiteId = (idx) => {
    //     setJobsiteIdCount(jobsiteIdCount-1);
    //     setValue(`jobsiteId.${idx}.jobsiteIdType`, '')
    //     setValue(`jobsiteId.${idx}.value`, '')
    //     setValue(`jobsiteId.${idx}.added`, false)
    // }


    // --------------------------------------------------------------------
    // return view
    // --------------------------------------------------------------------
    
    return (
        <>
        <div className='card p-0 my-3'>
            <h6 className="card-header">
                {t('Job Details')}
            </h6>
            <div className='card-body'>
            <Row>
                <Col>
                  {preloadedProject != null
                    ? <InputField label={t('Project Number *')} name={`assignmentInfo.project.name`} type='text' disabled={true} />
                    : <TypeaheadSelectorField 
                            handleSearch={null} 
                            handleTypeaheadChange={onProjectSelect}
                            isAsync={false}
                            isLoading={false}
                            isRequired={false}
                            label={t('Project Number *')}
                            name={'assignmentInfo.projectNumber'}
                            options={projects}
                            selectedOption={selectedProject}
                        />
                  }
                </Col>
            </Row>
            <Row>
                <Col className='ps-3'>
                    <SelectField 
                        label={t('Employer *')} 
                        disabled={!areProjectLoaded} 
                        isLoading={loadingEmployees} 
                        name={'assignmentInfo.organization'} 
                        options={employers} 
                        onChange={(e) => onEmployerSelect(e.target.selectedOptions[0].value)}
                    />
                </Col>
            </Row>
            <Row><Form.Label className='ps-3 float-left'>{t('EmployerLabel')}</Form.Label></Row>
            <Row>
                <Col>
                    <SelectField placeholder={' '} label={t('Role*')} name={'assignmentInfo.role'} options={roles}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <SelectField placeholder={' '} label={t('Crafts*')} name={'assignmentInfo.craft'} options={crafts} />
                </Col>
            </Row>
            
            {/* <JobsiteIdList 
                jobsiteIdTypes={jobsiteIdTypes} 
                disableJobsiteIdValues={disableJobsiteIdValue} 
                jobsiteIdCount={jobsiteIdCount}
                onChange={jobsiteIdTypeChange}
                addJobsiteId={addJobsiteId}
                removeJobsiteId={removeJobsiteId} /> */}
        </div>
        </div>
        </>
    )
}

export default AssignmentInfo;